import { gql } from '@apollo/client';

export const GET_LINE_ITEMS_TO_DUPLICATE = gql`
  query GetLineItemsToDuplicate($filterOptions: LineItemFilterOptionsV5, $limit: Int, $offset: Int) {
    lineItemsV5(filterOptions: $filterOptions, paginationOptions: { limit: $limit, offset: $offset }) {
      edges {
        node {
          id
          name
          startDate
          endDate
          billableThirdParty
          isCoppaOrCaru
          schedule {
            timezone
            deliveryInViewerTime
            dateRangeList {
              startDate
              endDate
              pacingShare
            }
            dayPartList {
              activeDayList
              firstActiveHour
              lastActiveHour
            }
          }
          campaign {
            id
            campaignTagList {
              id
              type
              url
              isVerified
            }
          }
          adProduct
        }
      }
      total
    }
  }
`;
